<template>
  <div class="flex flex-col items-end">
    <button
      type="button"
      data-testid="forgot-password"
      :disabled="sending"
      class="text-sm text-gray-500 hover:text-primary transition-colors duration-200 underline disabled:opacity-60"
      @click="send"
    >
      {{ sending ? "Invio in corso..." : "Password dimenticata?" }}
    </button>
    <p
      v-if="message"
      data-testid="forgot-password-message"
      role="status"
      :class="['mt-1 text-sm text-right', sent ? 'text-primary' : 'text-red-500']"
    >
      {{ message }}
    </p>
  </div>
</template>

<script>
// "Password dimenticata?" under a password field (#857): sends the reset email
// to the email of the login form, the same email the header login sends.
import {
  sendPasswordResetEmail,
  passwordResetBrand,
  PASSWORD_RESET_EMAIL_MISSING,
} from "@/services/passwordReset.js";

export default {
  name: "ForgotPasswordLink",
  props: {
    email: { type: String, default: "" },
    // Defaults to the brand of the page the visitor is on.
    brand: { type: String, default: "" },
  },
  emits: ["sent"],
  data() {
    return { sending: false, sent: false, message: "" };
  },
  watch: {
    email() {
      this.sent = false;
      this.message = "";
    },
  },
  methods: {
    async send() {
      if (this.sending) return;
      const email = (this.email || "").trim();
      this.sent = false;
      if (!email) {
        this.message = PASSWORD_RESET_EMAIL_MISSING;
        return;
      }
      this.sending = true;
      this.message = "";
      const { ok, message } = await sendPasswordResetEmail(email, this.brand || passwordResetBrand());
      this.sending = false;
      this.sent = ok;
      this.message = message;
      if (ok) this.$emit("sent", email);
    },
  },
};
</script>
